/* globals document */
import * as React from 'react';
import { autorun } from 'mobx';
import { inject } from 'mobx-react';

import { ContextStore, ExperimentStore } from 'bernie-core';

import { AdvertisingStore } from 'src/common/stores/advertising-store';

interface MesoInitProps {
  advertising?: AdvertisingStore;
  context?: ContextStore;
  experiment?: ExperimentStore;
  locale?: string;
  siteId?: string;
}

@inject('context', 'advertising', 'experiment')
export class MesoInit extends React.Component<MesoInitProps> {
  private halt: () => any;

  public componentDidMount() {
    // If window.meso.intialize is an event queue, the loader script was already added.
    if (!(window.meso && window.meso.initialize && window.meso.initialize.isEventQueue)) {
      // Dynamically add the loader script.
      /* istanbul ignore else */
      if (document) {
        const script = document.createElement('script');
        // Retrieve endpoint from advertising store.
        script.src = (this.props.advertising && this.props.advertising.adsloader) || '';
        script.type = 'module';
        document.body.appendChild(script);

        // ES5 script version to support older Microsoft browsers.
        const scriptES5 = document.createElement('script');
        // Retrieve endpoint from advertising store.
        scriptES5.src = (this.props.advertising && this.props.advertising.adsloaderes5) || '';
        scriptES5.defer = true;
        scriptES5.noModule = true;
        document.body.appendChild(scriptES5);
      }
    }

    // Initialize the page and get ads from delivery service.
    /* istanbul ignore else */
    if (window) {
      this.halt = autorun(() => {
        // Retrieve data from context.
        const pageName = this.props.advertising.triggeredPageName;
        const context = this.props.context;
        const siteId = (context && context.site && context.site.id) || '';
        const locale = (context && context.locale) || '';
        const { canTrack, canSell } = this.getPrivacyConsent();

        // Override with props data or use context.
        const target = {
          type: 'target',
          pageId: pageName,
          siteId: this.props.siteId || siteId,
          locale: this.props.locale || locale,
          variant: 'pwa',
          canTrack,
          canSell
        };

        window.meso = window.meso || {};

        // Push the application to the breakpoints framework.
        window.meso.breakpoints = window.meso.breakpoints || [];
        window.meso.breakpoints.push({ type: 'platform', platform: 'bernie' });

        // Push the target to ADS endpoint to load ads.
        window.meso.initialize = window.meso.initialize || [];
        window.meso.initialize.push(target);

        // Push experiment data to the experiments framework.
        window.meso.experiments = window.meso.experiments || [];
        window.meso.experiments.push({
          type: 'update',
          experiments: this.parseExperiments()
        });
      });
    }
  }

  private parseExperiments() {
    const result = {};
    const exposures = (this.props.experiment && this.props.experiment.exposures) || {};
    // Map experiment name to bucket id in result.
    Object.keys(exposures).forEach(key => {
      /* istanbul ignore else */
      if (exposures[key].hasOwnProperty('bucket')) {
        result[key] = exposures[key].bucket;
      }
    });

    return result;
  }

  private getPrivacyConsent() {
    // Retrieve data from context.
    const context = this.props.context;
    const optInPrivacy = context && context.site && context.site.optInPrivacyInfo;
    const canTrack = (optInPrivacy && optInPrivacy.canTrack) || false;
    // canSell defaults to true if it is not defined
    const canSell = !(optInPrivacy && optInPrivacy.canSell === false);

    return {
      canTrack,
      canSell
    };
  }

  public componentWillUnmount() {
    /* istanbul ignore else */
    if (typeof this.halt === 'function') {
      this.halt();
    }
  }

  public render() {
    return null;
  }
}
